$(function(){
    $('.iwish-seo-setting .seo-buttom span').on('click',function(){
        let t = $(this).text();
        if(t == 'Mostra altro'){
            $('.iwish-seo-setting .seo-container').removeClass('max-height');
            $(this).html('Nascosto');
        }else{
            $('.iwish-seo-setting .seo-container').addClass('max-height');
            $(this).html('Mostra altro');
        }
    });
});